import { Paper } from "@mui/material";
import React, { useState, useEffect } from 'react';
import "./Modal.css"; 

const MsgFinal = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const paperStyle = { borderRadius: '50px', padding: 25, marginRight: 5, marginLeft: 5, width: 'auto', height: '200px', marginTop: '25px', background: "#dceff7", color: "#000", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }
  const btn = { borderRadius: 15, border: '0px', background: '#fff', fontSize: 16, padding: 15 }
  // useEffect(() => {
  //   setTimeout(() => {
  //     window.location.reload();
  //   }, 4000);
  // },[]);

  function reload() {
    window.location.reload();
  }
  return (<>
                {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Agradecimentos!</h2>
                        <p>Muito obrigado por participar da nossa pesquisa!</p>
                        {/* <button onClick={closeModal}>OK</button> */}
                    </div>
                </div>
            )}
            </>
  )
}
export default MsgFinal;
